var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReduceErrors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.707107,
    y: 42.4264,
    width: 59,
    height: 39,
    rx: 19.5,
    transform: "rotate(-45 0.707107 42.4264)",
    fill: "#F3FAFF",
    stroke: "#CEECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7944 45L41.0343 42.7851M41.0343 42.7851L43.2731 40.5691M41.0343 42.7851L38.7933 40.5681M41.0332 42.784L43.2721 44.999M45 37.3099V32.0886C45 31.5346 44.7776 31.0034 44.3817 30.6117C43.9858 30.22 43.4488 30 42.8889 30H28.1111C27.5512 30 27.0142 30.22 26.6183 30.6117C26.2224 31.0034 26 31.5346 26 32.0886V38.3542C26 38.9081 26.2224 39.4394 26.6183 39.831C27.0142 40.2227 27.5512 40.4428 28.1111 40.4428H34.4444M35.5 35.2318L35.5106 35.2203M39.7222 35.2318L39.7328 35.2203M31.2778 35.2318L31.2883 35.2203",
    stroke: "#175677",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduceErrors);
export default __webpack_public_path__ + "static/media/Reduce Errors.f4a740667750e02b0984b264914dd31e.svg";
export { ForwardRef as ReactComponent };